import React from "react";
import ReactModalWrap from "../../UI/Modals/ReactModalWrap/ReactModalWrap";
import styles from "./ItemAvailabilityDescriptionModal.module.scss";

interface ItemAvailabilityDescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  description?: string;
  shortCode?: string;
  color?: string;
  needRP?: number;
}

export const ItemAvailabilityDescriptionModal: React.FC<
  ItemAvailabilityDescriptionModalProps
> = ({ isOpen, onClose, description, shortCode, color, needRP }) => {
  const customModalStyle = {
    content: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      minWidth: "100px",
    },
  };

  // Apply same styling logic as ItemAvailabilityBadge
  const isHighlighted = needRP === 1;
  const backgroundColor = isHighlighted ? color : "transparent";
  const textColor = isHighlighted ? "white" : color;
  const borderColor = color;

  return (
    <ReactModalWrap
      isOpen={isOpen}
      close={onClose}
      customStyle={customModalStyle}
    >
      <div className={styles.modalContent}>
        {shortCode && (
          <h3 className={styles.title}>
            Režim izdavanja:{" "}
            <strong
              className={styles.badge}
              style={{
                borderColor,
                backgroundColor,
                color: textColor,
              }}
            >
              {shortCode}
            </strong>
          </h3>
        )}
        <div className={styles.description}>
          {description || "Nema dostupnog opisa za ovaj režim izdavanja."}
        </div>
      </div>
    </ReactModalWrap>
  );
};

export default ItemAvailabilityDescriptionModal;
